import React, { PropsWithChildren } from 'react';

import { default as MuiSelect, SelectProps } from '@mui/material/Select';

const Select = function <T = unknown>(
  props: PropsWithChildren<SelectProps<T>>
): JSX.Element {
  return <MuiSelect {...props}>{props.children}</MuiSelect>;
};

export default Select;
